export default function windowScrollTop() {
  $("html, body").stop().animate({
    scrollTop: 0
  }, 500);
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/windowScrollTop', windowScrollTop);